import React, { useEffect, useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { useForm } from 'react-hook-form';
import './Login_signup.css'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Light_Black_Btn from '../../common_btn/light_black_btn/Light_Black_Btn';
import Cancel_Order_btn from '../../common_btn/cancel_Order_btn/Cancel_Order_btn';
import Set_New_Password_Modal from './Set_New_Password_Modal';
import Pink_Btn from '../../common_btn/pink_btn/Pink_Btn';
import { sendMobileOtp, verifyOtp } from '../../../../features/admin/auth/Slice';
import { useDispatch } from 'react-redux';

const Reset_Password_Modal = ({
    setEmail,
    setContact,
    setShowSetPassModal,
    contact, email,
    ...props
}) => {

    const {
        control, setError, setValue,
        register, reset,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const [showOtpDiv, setShowOtpDiv] = useState(false);

    const [timer, setTImer] = useState(15);
    const [disabled, setDisables] = useState(true);
    const dispatch = useDispatch()

    const [otp, setOtp] = useState(["", "", "", ""]);

    const handleInputChange = (e, index) => {
        const value = e.target.value;
        if (isNaN(value) || value.length > 1) {
            return;
        }

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < otp.length - 1) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };

    const handleKeyDown = async (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            document.getElementById(`otp-${index - 1}`).focus();
        }
    };
    const data = {};
    const onSubmit = async (user) => {
        console.log(user, "user user");

        const validator = require("validator");

        if (validator.isEmail(user.email)) {
            await setEmail(user.email);
            data.email = user.email;
        } else {
            await setContact(user.email);
            data.contact_no = user.email;
        }

        const res = await dispatch(sendMobileOtp(data));

        if (res.meta?.requestStatus === "fulfilled") {
            setTImer(45);
            setDisables(true);
            setShowOtpDiv(true);
            reset()
        } else if (res.meta?.requestStatus === "rejected") {
            setError("email", {
                type: "custom",
                message: "Email Address / Mobile  Number not Found",
            });
        }
    };
    const validateOTp = async () => {

        const otpValue = otp.join("");

        if (!otpValue) {
            setError("otp", { type: "manual", message: "OTP is required" });
            return;
        }

        const data = {
            email: email,
            contact_no: contact,
            otp: otpValue,
        };

        const verify = await dispatch(verifyOtp(data));

        if (verify.meta?.requestStatus === "fulfilled") {
            props?.onHide();
            setShowSetPassModal();
            setDisables(true);
            setShowOtpDiv(false);
            setOtp(["", "", "", ""]);
            reset()
        } else if (verify.meta?.requestStatus === "rejected") {
            setError("otp", {
                type: "manual",
                message: verify.payload?.errors,
            });
        }

    };
    const resendCode = async () => {
        const data = {
            email: email,
            contact_no: contact,
        };
        if (disabled) return;
        const res = await dispatch(sendMobileOtp(data));
        if (res.meta?.requestStatus === "fulfilled") {
            setTImer(90);
            setDisables(true);
        } else if (res.meta?.requestStatus === "rejected") {
            setShowOtpDiv(false);
            setError("")
        }

    };



    useEffect(() => {
        let interval;
        if (disabled) {
            interval = setInterval(() => {
                setTImer((prev) => {
                    if (prev === 1) {
                        clearInterval(interval);
                        setDisables(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [disabled]);



    return (

        <>
            <Modal className="Reset_Password_Modal Login_Modal" size='md' {...props} centered>

                <div className='absolute_div'>


                    <div className='logo_holder'>
                        <img src={process.env.PUBLIC_URL + '/assets/images/logo/logo.png'} className='logo_img' />
                    </div>
                </div>

                <Modal.Body>

                    {!showOtpDiv && (
                        <div className='reset_pass_main_form'>
                            <div className='close_img_div' >
                                <div className='title_div'>
                                    <p className='title'>Please wait for OTP verification</p>
                                    <p className='sub_text'>Hold on, we will send you OTP code on your mobile number</p>
                                </div>
                                <img src={process.env.PUBLIC_URL + '/assets/images/icons/close.png'} className='close_img' onClick={() => { props?.onHide() }} />
                            </div>


                            <div className='reset_pass_div login_div'>
                                <div className='login_form_div'>
                                    <Form>
                                        <Form.Group className="gray_input_group input_group">
                                            <Form.Label>Email / Mobile Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter your email or mobile number"
                                                {...register("email", {
                                                    required: "Email is required",
                                                })}
                                            />
                                            {errors.email && (
                                                <div className="text-danger">{errors.email.message}</div>
                                            )}
                                        </Form.Group>
                                    </Form>
                                </div>

                                <div className='btns_holder'>
                                    <Pink_Btn btnText={"Submit"}
                                        // onClick={() => { setShowOtpDiv(true) }}
                                        onClick={handleSubmit(onSubmit)}
                                    />
                                    <Cancel_Order_btn btnText={"Cancel"} onClick={() => { props?.onHide() }} />
                                </div>
                            </div>

                        </div>
                    )}

                    {showOtpDiv && (
                        <div className='otp_main_div'>

                            <div className='close_img_div' >
                                <div className='title_div'>
                                    <p className='title'>OTP has been Sent </p>
                                    <p className='title'>to the Email / Mobile Number</p>
                                </div>
                                <img src={process.env.PUBLIC_URL + '/assets/images/icons/close.png'} className='close_img' onClick={() => { props?.onHide() }} />
                            </div>


                            <div className="Otp-field-holder">
                                {otp.map((value, index) => (
                                    <Form.Control
                                        key={index}
                                        type="text"
                                        className="otp-field"
                                        maxLength="1"
                                        value={value}
                                        id={`otp-${index}`}
                                        onChange={(e) => handleInputChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                    />
                                ))}
                                {errors.otp && (
                                    <div style={{ color: "red" }}>{errors.otp.message}</div>
                                )}
                            </div>

                            <div className='btns_holder'>

                                <p
                                    className={`link_text ${disabled ? "disabled" : ""}`}
                                    onClick={!disabled ? resendCode : undefined}
                                >
                                    {disabled ? `Resend Code in ${timer}s` : "Resend Code"}
                                </p>

                                <Light_Black_Btn btnText={"Submit"} onClick={() => {
                                    validateOTp()
                                    // props?.onHide()
                                    // props?.setShowSetPassModal()
                                }} />
                            </div>



                        </div>
                    )}

                </Modal.Body>


            </Modal>


        </>
    )
}

export default Reset_Password_Modal